import React, {useEffect, useState} from 'react';
import CreateOrganizationUI from '../view/CreateOrganizationUI';
import CreateOrganizationStore from '../store/CreateOrganizationStore';
import {inject, observer} from 'mobx-react';
import NavigationStore from '../../../navigation/store/NavigationStore';
import {useParams} from 'react-router-dom';
import TourPromptModal from '../view/TourPromptModal';
import {
  markAllTourSectionsSeen,
  resetAllTourSections,
} from '../../Tour/utils/tourStorage';

interface Props {
  isOpen: boolean;
  onClose: (payload?: any) => void;
  createOrganizationStore?: CreateOrganizationStore;
  navigationStore?: NavigationStore;
}

const CreateOrganizationContainer = inject(
  'createOrganizationStore',
  'navigationStore',
)(
  observer(
    ({isOpen, onClose, createOrganizationStore, navigationStore}: Props) => {
      const {organizationId} = useParams();
      const [showTourPrompt, setShowTourPrompt] = useState(false);

      useEffect(() => {
        return () => {
          createOrganizationStore!.clearErrors();
        };
      }, []);

      const onCreateOrganization = async (
        name: string,
        primaryColor: string,
        secondaryColor: string,
        type: number,
        llmProvider?: string,
        image?: File,
      ) => {
        if (!organizationId) return;
        const result = await createOrganizationStore!.createOrganization(
          organizationId,
          name,
          type,
          image,
        );
        if (result) {
          await navigationStore!.tryGetMyOrganization();
          setShowTourPrompt(true);
        }
      };

      const clearErrors = () => {
        createOrganizationStore!.clearErrors();
      };

      const handleTourYes = () => {
        resetAllTourSections();
        setShowTourPrompt(false);
        onClose();
      };

      const handleTourNo = () => {
        markAllTourSectionsSeen();
        setShowTourPrompt(false);
        onClose();
      };

      return isOpen ? (
        <>
          <CreateOrganizationUI
            onCreateOrganization={onCreateOrganization}
            isLoading={createOrganizationStore!.isLoading}
            errors={createOrganizationStore!.errors}
            clearErrors={clearErrors}
          />
          <TourPromptModal
            isOpen={showTourPrompt}
            onYes={handleTourYes}
            onNo={handleTourNo}
          />
        </>
      ) : (
        <div />
      );
    },
  ),
);

export default CreateOrganizationContainer;
